import { render } from "./SupplierSubcategoryTab.vue?vue&type=template&id=46b8e360"
import script from "./SupplierSubcategoryTab.vue?vue&type=script&lang=js"
export * from "./SupplierSubcategoryTab.vue?vue&type=script&lang=js"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__